module.exports = __webpack_public_path__ + "static/images/containers/Journal/images/update-icon.5276b5be.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Journal/images/update-icon.png
// module id = 3110
// module chunks = 11